import { render, staticRenderFns } from "./LoadingDeadlineReportChart.vue?vue&type=template&id=28dc6ba4&scoped=true&"
import script from "./LoadingDeadlineReportChart.vue?vue&type=script&lang=js&"
export * from "./LoadingDeadlineReportChart.vue?vue&type=script&lang=js&"
import style0 from "./LoadingDeadlineReportChart.vue?vue&type=style&index=0&id=28dc6ba4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dc6ba4",
  null
  
)

export default component.exports